import React from 'react';
import * as R from 'ramda';
import { Link } from 'react-router-dom';
import classNames from 'classnames';
import { Tooltip } from 'Components/nui';
import { specConst } from '~/utils';
import Icon from 'Components/Icon';
import { useIntl } from 'react-intl';

export const SpecButtons = ({ product, children }) => {
  const { formatMessage } = useIntl();
  const icons = R.uniq(
    product.specifications.map((item) => R.path(['compliance', 'id'], item))
  ).filter((x) => x);

  if (icons.length === 0 && !children) return null;

  const getTooltipText = (id) => {
    switch (id) {
      case 10000:
        return formatMessage({
          id: 'spec-specifications-tooltip',
          defaultMessage: 'Specifications',
        });
      case 10001:
        return formatMessage({
          id: 'spec-halal-tooltip',
          defaultMessage: 'Halal docs',
        });
      case 10002:
        return formatMessage({
          id: 'spec-kosher-tooltip',
          defaultMessage: 'Kosher docs',
        });
      case 10003:
        return formatMessage({
          id: 'spec-organic-tooltip',
          defaultMessage: 'Organic docs',
        });
      case 10004:
        return formatMessage({
          id: 'spec-other-tooltip',
          defaultMessage: 'Other docs',
        });
      case 10005:
        return formatMessage({
          id: 'spec-low-carbon-tooltip',
          defaultMessage: 'Low carbon docs',
        });
      default:
        return '';
    }
  };

  return (
    <ul className="legend-list tw:!flex tw:items-center">
      {icons.map((id) => (
        <li key={id}>
          <Tooltip
            title={
              <span className="icon-tooltip">
                <span className="icon-info-circled" />
                {getTooltipText(id)}
              </span>
            }
          >
            <Link
              to={`/products/${product.id}/specifications#${specConst[id]?.anchorText}`}
              className={classNames('legend', specConst[id]?.className)}
              onClick={(e) => e.stopPropagation()}
            >
              {id === 10005 ? <Icon name="co2" /> : specConst[id]?.symbol}
            </Link>
          </Tooltip>
        </li>
      ))}
      {children}
    </ul>
  );
};
